import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import { _st } from './softech';
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment';


export const bus = new Vue();

Vue.config.productionTip = false;

Vue.mixin({
	methods: {
		can( privilege ) {
			return !_st.isNU( store.getters['auth/user'].privileges[privilege] );
		},
		mxShowMessage(text, color, timeout = 6000) {
			bus.$emit('alert', { text, color, timeout });
		},
		numbersOnly(e) {
			// Allow: backspace, delete, tab, escape, enter and .
			if (
				[46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
				// Allow: Ctrl/cmd+A
				(e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: Ctrl/cmd+C
				(e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: Ctrl/cmd+X
				(e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: home, end, left, right
				(e.keyCode >= 35 && e.keyCode <= 39)
			) {
				// let it happen, don't do anything
				return;
			}

			// Ensure that it is a number and stop the keypress
			if (
				(e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
				(e.keyCode < 96 || e.keyCode > 105)
			) {
				e.preventDefault();
			}
		},
		formatMoney(v) {
			return _st.isNUE(v) ? _st.toMoney(0) : _st.toMoney(v);
		},
		formatNumber(v, p = 0) {
			return _st.isNUE(v) ? _st.toFixedNumber(0, p) : _st.toFixedNumber(v, p);
		},
		formatPhoneNum(v) {
			return _st.toPhoneNumber(v);
		},
		intOnly(e) {
			// Allow: backspace, delete, tab, escape, enter and .
			if (
				[46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
				// Allow: Ctrl/cmd+A
				(e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: Ctrl/cmd+C
				(e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: Ctrl/cmd+X
				(e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
				// Allow: home, end, left, right
				(e.keyCode >= 35 && e.keyCode <= 39)
			) {
				// let it happen, don't do anything
				return;
			}

			// Ensure that it is a number and stop the keypress
			if (
				(e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) &&
				(e.keyCode < 96 || e.keyCode > 105)
			) {
				e.preventDefault();
			}
		},
		orderStatusColor( status ) {
            switch( status.toLowerCase() ) {
                case 'not fitted':
                case 'new order':
                case 'not printed':
                    return 'grey darken-1'

                case 'processing':
                case 'qc processing':
				case 'waiting for final inspection':
				case 'tailoring':
                case 'shipping':
                case 'truck line':
                    return 'warning';

                case 'store rack':
                    return 'primary';

                case 'out not billed':
                case 'out on rental':
                case 'void':
                case 'inactive':
                    return 'teal';

                case 'partial ret.':
                case 'returned':
                    return 'green'

                case 'cancelled':
                case 'not picked up':
                    return 'red';
            }

            return '';
        },
		mxCoatExist(items) {
			if (items == undefined) return false;

			return (
				items.filter(i => i.categoryId??i.categoryID == 'C').length > 0
			);
		},
		mxSubtotal(items) {
			if (items == undefined || items == null) return 0;

			let subtotal = 0;
			let coatExist = this.mxCoatExist(items);

			items.forEach((i) => {
				if( i == undefined ) return;

				if( coatExist && ( i.categoryID??i.categoryId ) == 'C' ) {
					subtotal = parseFloat(i.price);
					return;
				} 
				else if( !coatExist ) 
					subtotal += parseFloat(i.price);
			});

			return subtotal;
		},
		mxTotalPromoDiscount(promoCodes) {
			if ( _st.isNUE( promoCodes ) )
				return 0;

			let total = 0;
			promoCodes.forEach((p) => {
				if (p == undefined) return;

				total += parseFloat(p.amount);
			});

			return total;
		},
		mxDamageWaiver(items) {
			if (items == undefined || items == null) return 0;

			return items.length > 0 ? 10 : 0;
		},
		mxExtraItems(items) {
			if (items == undefined || items == null) return [];

			let currentItems = [];
			let xtraItems = [];

			items.forEach((p) => {
				if (p == undefined) return;

				let categoryId = p.categoryID??p.categoryId;

				if( currentItems.filter((i) => { return i.categoryId == categoryId; }).length == 0 ) {
					currentItems.push({
						categoryId: categoryId,
						category: p.category,
						qty: 1,
					});
				} else {
					let item = currentItems.find((i) => {
						return i.categoryId == categoryId;
					});

					item.qty++;
				}
			});

			currentItems.forEach((ci) => {
				if (ci.qty > 1) {
					let ei = store.getters['extraItems/extraItems'].find((eic) => { return eic.categoryId == ci.categoryId; });
					let amount = _st.isNUE( ei ) ? 0 : ei.amount;
					xtraItems.push({
						categoryId: ci.categoryId,
						category: ci.category,
						qty: ci.qty - 1,
						amount: (ci.qty - 1) * amount,
					});
				}
			});

			return xtraItems;
		},
		mxTotalExtraItems(items) {
			let total = 0;
			this.mxExtraItems(items).forEach((xi) => {
				total += parseFloat(xi.amount);
			});

			return total;
		},
		mxTotalCharges(charges) {
			if ( _st.isNUE( charges ) )
				return 0;

			let total = 0;
			charges.forEach((c) => {
				if (c == undefined) return;

				total += parseFloat(c.amount);
			});

			return total;
		},
		mxTax(items, promoCodes, charges) {
			return (
				(this.mxSubtotal(items) +
					this.mxDamageWaiver(items) +
					this.mxTotalCharges(charges) +
					this.mxTotalExtraItems(items) -
					this.mxTotalPromoDiscount(promoCodes)) *
				0.115 // store.getters.store.tax
			); // 0.115; // *** cambiar el rate del tax por una variable
		},
		mxTotal(items, promoCodes, charges) {
			return (
				this.mxSubtotal(items) 
				+ this.mxDamageWaiver(items) 
				+ this.mxTotalCharges(charges) 
				+ this.mxTotalExtraItems(items) 
				+ this.mxTax(items, promoCodes, charges) 
				- this.mxTotalPromoDiscount(promoCodes)
			);
		},
		createCsvArray(headers, data) {
			let result = [];
			result.push( headers.map(item => item.text) );
	
			data.forEach(item => {
				let tmp = [];
				
				headers.forEach(h => {
					let val = item[h.value] == null ? '' : item[h.value];
	
					switch( h.formatter ) {
						case 'money': val = _st.toMoney( val ); break;
						case 'integer': val = _st.toFixedNumber( val, 0 ); break;
						case 'na': break;
					}
	
					tmp.push(val.toString().replace(',', ''));
				});
				result.push(tmp);
			});
	
			return result;
		},
		createPdfArray(headers, data) {
			let result = [];
	
			data.forEach(item => {
				let tmp = [];
				
				headers.forEach(h => {
					let val = item[h.value] == null ? '' : item[h.value];
	
					switch( h.formatter ) {
					case 'money': val = _st.toMoney( val ); break;
					case 'integer': val = _st.toFixedNumber( val, 0 ); break;
					case 'perc': val = _st.toFixedNumber( val, 2 ) + '%'; break;
					case 'datetime': val = moment( val, 'YYYY-MM-DD HH:mm:ss' ).format( 'YYYY-MM-DD hh:mm a' ); break;
					case 'date': val = moment( val, 'YYYY-MM-DD' ).format( 'YYYY-MM-DD' ); break;
					case 'na': break;
					}
	
					tmp.push(val);
				});
				result.push(tmp);
			});
	
			return result;
		},
		exportPdf(headers, data) {
			let pdf = new jsPDF('p','px', 'letter', true);
	
			pdf.addImage(this.getLogoUrl(), 'png', 30, 30, 50, 25);
			pdf.setLineWidth(0.1);
			pdf.line(88, 30, 88, 60);
			pdf.text(this.$route.name, 95, 48);
	
			// window.console.log(this.rptData);
			// pdf.table(10, 10, data, []);
			pdf.autoTable(headers.map(h => h.text), data, { 
				styles: { cellPadding: 1, fontSize: 8 },
				startY: 80,
				didParseCell: (data) => {                    
					data.cell.styles.halign = (headers[data.column.index].align == undefined ? 'left' : headers[data.column.index].align);
				}
			});
			pdf.save( encodeURI( this.$route.name ) + '.pdf');
		},
		getLogoUrl() {
			return 'data:image/png;base64,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';
		}
	}
});

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
